import React from 'react';

const CameraStatusBubble = ({ status }) => {
	return (
		<div className="flex items-center">
			<div className="rounded-[6px] flex  gap-4 items-center border shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] border-[#D5D7DA] py-2 px-6 min-w-[77px]">
				<div className={`size-[6px] rounded-full ${status ? 'bg-green-500' : 'bg-red-500'}`} />
				<span className="font-medium font-inter text-[#414651]">{status ? 'Active' : 'Inactive'}</span>
			</div>
		</div>
	);
};

export default CameraStatusBubble;
